/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React from 'react'
import ReactSelect from 'react-select'

const regionStyle = {
  control: styles => ({ ...styles, backgroundColor: 'white', minWidth: '180px' })
}

export default ({ region, options, onChange }) => (
  <div css={regionDropdown}>
    <ReactSelect
      className='alt-region-select'
      classNamePrefix='region-select'
      options={options}
      onChange={onChange}
      value={region}
      styles={regionStyle}
    />
  </div>
)

const regionDropdown = css`
  padding-left: 30px;
`
